<template>
    <div class="flex flex-col self-center lg:min-w-fit border-2 rounded p-2 pt-1 informationContainer h-auto mx-1 "
        :class="inputTable !== undefined ? 'infoTable ' : ''" style="scrollbar-width: thin;">
        <!-- <label class="font-bold mb-0.5 min-w-max w-auto flex self-center">
            Details: </label> -->
        <div class="flex flex-col min-w-fit h-fit w-fit">
            <label class="font-bold mb-0.5 min-w-max w-auto flex self-center">
                Details: </label>
            <div class="flex relative" :class="warning ? 'pt-4' : ''">
                <span v-if="warning"
                    class="text-red-500 text-xs pl-1 absolute top-[-5px] flex w-full justify-center">Please fill in
                    required fields</span>
                <div class="detailsGrid min-w-fit pr-2">
                    <li v-for=" info, key in information" :key="key" class="list-none text-base ">
                        <label class="font-bold mb-1 w-1/3 h-6 text-center min-w-min pl-2 content-center">
                            {{ key }}:
                        </label>
                        <span v-if="!info.required" class="text-xs items-center">(optional)</span>
                    </li>
                    <span v-if="membersTotal !== undefined" class="font-bold w-1/3 text-center min-w-max px-2 h-6">
                        {{ membersTotal }} Members
                    </span>
                </div>
                <div class="detailsGrid min-w-fit ">
                    <li v-for=" info, key in information" :key="key" class="list-none ml-3 text-base relative">
                        <Dropdown v-if="information[key].type == 'dropdown'" v-model="information[key].value"
                            :options="information[key].options"
                            class="text-center rounded-md border-2 shadow-none min-w-fit h-6 mb-1 font-semibold text-black-900 w-64" />
                        <AutoComplete v-else-if="information[key].type == 'autoComplete'" dropdown
                            @complete="dropDownSearch($event, information[key].options)"
                            v-model="information[key].value" :suggestions="filteredValues"
                            class="rounded-md border-2 min-w-fit h-6 mb-1 font-semibold text-black-900 w-64" />
                        <InputNumber v-else-if="information[key].type == 'inputNumber'" v-model="information[key].value"
                            :minFractionDigits="0" :maxFractionDigits="8"
                            class="rounded-md border-2 shadow-none min-w-fit h-6 mb-1 font-semibold text-black-900 w-64" />
                        <Calendar v-else-if="information[key].type == 'calendar'" v-model="information[key].value"
                            dateFormat="yy-mm-dd" currentView="year"
                            class="rounded-md border-2 shadow-none min-w-fit h-6 mb-1 font-semibold text-black-900 w-64"
                            showIcon :showTime="false" />
                        <Inplace v-else-if="information[key].type == 'textarea'" class="w-max" :closable="true"
                            pt:display:class="p-0.5 m-0 w-64 h-6 border-2 shadow-none rounded-md flex items-center justify-center text-center">
                            <template #display>
                                <span class="flex justify-end w-full">
                                    <span class="w-full self-center">{{ information[key].value.slice(0, 25) }} </span>
                                    <i class="pi pi-pencil float-right self-center px-2"></i>
                                </span>
                            </template>
                            <template #content>
                                <Textarea v-model="information[key].value" cols="60" rows="1" autoResize
                                    class="text-left rounded-md border-2 outline-none min-w-fit text-black-900" />
                            </template>
                            <template #closeicon><i class="pi pi-check text-black"></i></template>
                        </Inplace>
                        <InputText v-else v-model="information[key].value"
                            class="text-center rounded-md border-2 shadow-none min-w-fit h-6 mb-1 font-semibold text-black-900 w-64" />
                    </li>
                </div>
            </div>
        </div>
        <div v-if="inputTable !== undefined" class=" editTable w-full overflow-visible relative">
            <DataTable :value="inputTable" :pt="{
            wrapper: {
                class: ['text-sm !overflow-visible'],
            },
            root: {
                style: {
                    'height': editTableHeight,
                }
            }
        }" v-model:editingRows="editingRows" pt:table:class="mt-2" editMode="row" @row-edit-save="onRowEditComplete">
                <Column :pt="{ headerCell: { style: { 'min-width': '40px' } } }">
                    <template #body="{ data }">
                        <Button icon="pi pi-trash" class="hover:bg-gray-200 trash-icon"
                            @click=" $emit('remove', data); editTableHeightNum -= 30.5; editTableHeight = editTableHeightNum + 'px'" />
                    </template>
                    <!-- Remove trash button while row in edit mode -->
                    <template #editor>
                        <span></span>
                    </template>
                </Column>
                <Column v-for=" col  of  tableColumns " :key="col.key" :field="col.key"
                    :header="col.name.toUpperCase()">
                    <template #body="{ data, field }">
                        <span>{{ data[field] }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" :pt="{
            root: {
                style: {
                    'min-width': (col.name.length * 10) + 16 + 'px',
                    'box-shadow': '0 0 0 0.1rem #e5e7eb',
                    'padding-left': '2px',
                    'padding-bottom': '2px'
                }
            }
        }" :style="'width:' + (((data[field].length) * 10) + 8) + 'px'" />
                    </template>
                </Column>
                <Column :rowEditor="true" style="width: 7%; min-width: 5rem; height: 3px" bodyStyle="text-align:center">
                </Column>
            </DataTable>
            <Button icon="pi pi-plus text-green-800" class="hover:bg-gray-200 plus-icon absolute top-3 left-1.5"
                @click="addEmptyRowToInfoTable(); editTableHeightNum += 30.5; editTableHeight = editTableHeightNum + 'px'"></Button>
        </div>
    </div>

</template>
<script lang="ts" setup>
import { defineProps, ref, onMounted, defineEmits } from 'vue';

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import AutoComplete from 'primevue/autocomplete';
import InputNumber from 'primevue/inputnumber';
import Calendar from 'primevue/calendar';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import Inplace from 'primevue/inplace';

const props = defineProps(['information', 'membersTotal', 'inputTable', 'tableColumns', 'warning'])
const emit = defineEmits(['remove'])

const information = ref(props.information)
const inputTable = ref(props.inputTable)
const infoLength = { length: props.membersTotal !== undefined ? Object.keys(props.information).length + 1 : Object.keys(props.information).length }

const filteredValues = ref();
const editingRows: any = ref([]);
const editTableHeight = ref('auto')
const editTableHeightNum = ref(0)

onMounted(async () => {
    if (props.inputTable !== undefined)
        setTableHeight()

    Object.keys(information.value).forEach(element => {
        if (Array.isArray(information.value[element].value))
            information.value[element].value = information.value[element].value.join(' ')
    });
})

/**
 * DropDown Search
 */
const dropDownSearch = (event: any, items: any) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            filteredValues.value = [...items];
        } else {
            filteredValues.value = items.filter((value: string) => {
                return value.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }
    }, 250);
}

const onRowEditComplete = (event: any) => {
    let { newData, index } = event;
    inputTable.value[index] = newData;
};

function addEmptyRowToInfoTable() {
    let tempObject: any = {}
    props.tableColumns.forEach((element: { key: string }) => {
        tempObject[element.key] = ""
    });
    inputTable.value.push(tempObject)
}

/**
 * Manually set datatable root component container to height of table
 */
function setTableHeight() {
    let emptyTableRec = document.getElementsByClassName("p-datatable-wrapper")[3]
    if (emptyTableRec == undefined) {
        emptyTableRec = document.getElementsByClassName("p-datatable-wrapper")[0]
    }
    if (emptyTableRec !== undefined) {
        editTableHeightNum.value = emptyTableRec.getBoundingClientRect().height
        editTableHeight.value = (editTableHeightNum.value).toString() + 'px'
    }
}

</script>

<style>
.detailsGrid {
    display: grid;
    grid-template-rows: repeat(v-bind('infoLength.length'), 1fr)
}

.trash-icon span,
.plus-icon span {
    padding: 0px !important;
}

.editTable .generic-table-div {
    overflow: visible;
}

.informationCardTable table,
.editTable table {
    border: 1px solid #e5e7eb;
}

.p-datatable th,
.p-datatable td {
    padding: 3px 5px;
    width: auto;
    overflow: hidden;
    white-space: nowrap;
}

.p-datatable-table {
    max-width: min-content
}

.informationCardTable th,
.informationCardTable span,
.editTable th,
.editTable span {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
    color: black;
}

.informationCardTable th,
.informationCardTable span {
    padding: 1px 3px !important;
}

@media (min-width: 640px) {

    .informationCardTable th,
    .informationCardTable span,
    .editTable th,
    .editTable span {
        font-size: 0.875rem !important;
        line-height: 1.5rem !important;
        color: black;
    }

    .informationCardTable th,
    .informationCardTable span {
        padding: 1px 4px !important;
    }
}
</style>